import { render, staticRenderFns } from "./chatDialog.vue?vue&type=template&id=50eb6c13&scoped=true&"
import script from "./chatDialog.vue?vue&type=script&lang=js&"
export * from "./chatDialog.vue?vue&type=script&lang=js&"
import style0 from "./chatDialog.vue?vue&type=style&index=0&lang=css&"
import style2 from "./chatDialog.vue?vue&type=style&index=2&id=50eb6c13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb6c13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50eb6c13')) {
      api.createRecord('50eb6c13', component.options)
    } else {
      api.reload('50eb6c13', component.options)
    }
    module.hot.accept("./chatDialog.vue?vue&type=template&id=50eb6c13&scoped=true&", function () {
      api.rerender('50eb6c13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/chatDialog.vue"
export default component.exports